import React from 'react';
import { graphql } from 'gatsby';
import { Layout, SEO } from '../../../components';
import ScheduleConsultation from '../../../components/page/rta/v3/home';
import { getSessionStorage } from '../../../components/utilities/functions';

const ScheduleConsultationPage = () => {
	const sem_referral = getSessionStorage('sem_referral');

	return (
		<Layout
			hideHeader={sem_referral}
			hideLeadGen
		>
			<ScheduleConsultation />
		</Layout>
	);
};

export default ScheduleConsultationPage;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = ({ data }) => <SEO {...data.contentstackStandardRta.seo} />;

export const query = graphql`
	query {
		contentstackStandardRta(uid: { eq: "bltfc3fa65c149fc29d" }) {
			seo {
				...SEO
			}
		}
	}
`;
